import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivitiesLiteComponent } from './activities-lite.component';
import { ActivitiesListComponent, checkAcceptReservationsPipe } from './activities-list/activities-list.component';
import { ActivitiesLiteRoutingModule } from './activities-lite-routing.module';
import { MaterialModule } from '../material-module';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ActivitySessionSelectionComponent, SafeHtmlPipe } from './activity-session-selection/activity-session-selection.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ActivitiesLiteOrderSummaryComponent, FilterTaxTypePipe, GetAddonNamePipe, GetTaxDescriptionPipe, GroupItemByType } from './activities-lite-order-summary/activities-lite-order-summary.component';
import { ActivityCartComponent } from './activity-cart/activity-cart.component';
import { ActivityBookingConfirmationComponent } from './activity-booking-confirmation/activity-booking-confirmation.component';
import { ActivitiesLiteCheckOutComponent } from './activities-lite-check-out/activities-lite-check-out.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ActivitiesLiteGuestDataComponent, GetCategoryDataPipe, viewMorePipe } from './activities-lite-guest-data/activities-lite-guest-data.component';
import { ActivitiesLayoutComponent } from './activities-layout/activities-layout.component';
import { LayoutFunctions } from './activities-layout/layout-functions';
import { DurationValueDirective } from '../shared/directives/duration-value.directive';
import { ActivitiesLiteSecondaryGuestDataComponent } from './activities-lite-secondary-guest-data/activities-lite-secondary-guest-data.component';
import { GroupByPipe, SizeMappingComponent } from './size-mapping/size-mapping.component';
import { ActivitesGuestPriceSummaryComponent } from './activites-guest-price-summary/activites-guest-price-summary.component';

@NgModule({
  declarations: [
    ActivitiesLiteComponent,
    ActivitiesListComponent,
    ActivitySessionSelectionComponent,
    ActivitiesLayoutComponent,
    ActivitiesLiteOrderSummaryComponent,
    ActivityCartComponent,
    ActivityBookingConfirmationComponent,
    ActivitiesLiteCheckOutComponent,
    checkAcceptReservationsPipe,
    ActivitiesLiteGuestDataComponent,
    viewMorePipe,
    GetCategoryDataPipe,
    GetAddonNamePipe,
    DurationValueDirective,
    ActivitiesLiteSecondaryGuestDataComponent,
    GetTaxDescriptionPipe,
    FilterTaxTypePipe,
    GroupItemByType,
    SafeHtmlPipe,
    SizeMappingComponent,
    GroupByPipe,
    ActivitesGuestPriceSummaryComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    // OwlDateTimeModule,
    ActivitiesLiteRoutingModule,
    // OwlNativeDateTimeModule,
    QRCodeModule
  ],
  providers: [
    LayoutFunctions,
    GetCategoryDataPipe
  ]
})
export class ActivitiesLiteModule { }
